/**
 * Detect seeded/demo properties so the UI can show a "test purpose only" notice.
 * Logic aligned with server `demoSeedFilter.js` — only explicit seed tags / demo hosts.
 */

const DEMO_KEYWORD_PREFIXES = ['ubsa-seed-stay', 'ubsa-seed-meeting', 'ubsa-demo'];
const DEMO_HOST_EMAILS = ['dummyhost@ubsaapp.local', 'public-meeting-rooms@ubsaapp.local'];

const toLower = (value) => String(value || '').trim().toLowerCase();

const hasDemoKeyword = (keywords) => {
  const list = Array.isArray(keywords)
    ? keywords
    : String(keywords || '')
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);

  return list.some((keyword) => {
    const normalized = toLower(keyword);
    return (
      DEMO_KEYWORD_PREFIXES.some((prefix) => normalized.startsWith(prefix)) ||
      normalized === 'demo'
    );
  });
};

export const isDemoProperty = (property) => {
  if (!property) return false;

  if (property.isDemo === true) return true;
  if (hasDemoKeyword(property.keywords)) return true;

  const rules = toLower(property.rules);
  if (DEMO_KEYWORD_PREFIXES.some((prefix) => rules.includes(prefix))) return true;

  const host = property.hostId || property.host || {};
  const hostEmail = toLower(
    (typeof host === 'object' ? host.email : '') || property.hostEmail
  );
  if (DEMO_HOST_EMAILS.includes(hostEmail)) return true;

  return false;
};

export default isDemoProperty;
